export enum AvailableBulkTypes {
  CANCEL_TRANSFERS = "cancelTransfers",
  EXPIRE_TRANSFERS = "expireTransfers",
  ACTIVATE_TRANSFERS = "activateTransfers",
}

export enum AvailableBulkResources {
  TRANSFER = "unitTransfers",
}

export type AvailableBulkTypesUnion = `${AvailableBulkTypes}`;
export type AvailableBulkResourcesUnion = `${AvailableBulkResources}`;

export interface BulkListItem {
  bulkActionId: string;
  comment: string;
  email: string;
  errorMessage?: string;
  fileName: string;
  processedRowCount: number;
  requestedAt: string;
  resource: AvailableBulkResources;
  type: AvailableBulkTypes;
  user: string;
  userId: string;
}

export interface BulkDetailsListItem {
  bulkActionItemId: string;
  objectToProcessId: string;
  message: string;
  status: BulkStatus;
  type: AvailableBulkTypes;
}

export enum BulkStatus {
  COMPLETED = "completed",
  IN_PROGRESS = "inprogress",
  ERROR = "error",
  FAILED = "failed",
  QUEUED = "queued",
}

export type BulkStatusUnion = `${BulkStatus}`;
